import React, { useState, useRef } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

function AdrTentativeAgreementChangeJustificationModalV3(props) {
  const {
    showModal,
    toggleModal,
    changeJustification: changeJustificationFromProps,
    updateChangeJustification,
    cancelChange,
    updateCachedValues,
  } = props;

  const [formErrors, setFormErrors] = useState({ changeJustification: null });
  const [changeJustification, setChangeJustification] = useState("");
  const formFields = useRef(["changeJustification"]);

  useEffect(() => validateForm(), [changeJustification]);

  /**
   * @param {string[]} fields - string array of field names to validate
   */
  const validateForm = (fields = []) => {
    if (fields.length === 0) fields = formFields.current;
    fields.forEach((field) => {
      switch (field) {
        case "changeJustification":
          if (!changeJustification.trim())
            setFormErrors({ ...formErrors, changeJustification: "Required" });
          else setFormErrors({ ...formErrors, changeJustification: null });
          break;
        default:
          break;
      }
    });
  };

  const formIsIncomplete = () => formErrors.changeJustification || !changeJustification;

  const toggleModal_internal = () => {
    if (!formIsIncomplete()) {
      // Replace any semicolons to commas in the changeJustification, since ; is used to split the
      // combined changeJustifications
      const cj = changeJustification.replace(/;/, ",");
      updateChangeJustification(`${changeJustificationFromProps || ""} Reason: ${cj}`);
      updateCachedValues();
      toggleModal();
    }
  };

  const handleChange = (e) => setChangeJustification(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    toggleModal_internal();
  };

  const handleClick_cancel = (e) => {
    e.preventDefault();
    cancelChange();
    toggleModal();
  };

  const renderPrevChangeJustifications = () => {
    /** @type {string[]} */
    const splitCjs = (changeJustificationFromProps || "")
      .split(";")
      .filter((cj) => cj.trim());
    return splitCjs.map((cj, index) => {
      const isLast = index === splitCjs.length - 1;
      return (
        <div
          key={`prevCjKey_${index}`}
          className={`d-flex flex-row alert alert-${
            isLast ? "info" : "warning"
          } w-100 p-1 mb-1`}
        >
          <span className="text-small">
            {cj.trim()}
            {isLast && <b> Input the reason for this change below.</b>}
          </span>
        </div>
      );
    });
  };

  return (
    <Modal isOpen={showModal} toggle={toggleModal_internal} size={"md"} fade={false}>
      <ModalHeader className="bg-warning">
        <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
        Change Justification
      </ModalHeader>
      <ModalBody>
        <label className="mb-0">
          <b>Log of Change(s):</b>
        </label>
        {renderPrevChangeJustifications()}
        <div className="d-flex flex-row w-100 form-group mb-0">
          <label className="mb-0" htmlFor="changeJustification">
            <b>Reason for Change:</b>*
          </label>
        </div>
        <div className="d-flex flex-column w-100 form-group mb-0">
          <textarea
            name="changeJustification"
            id="changeJustification"
            rows="5"
            className="form-control"
            value={changeJustification}
            onChange={handleChange}
          />
          {formErrors.changeJustification && (
            <span className="error-small">
              <small>{formErrors.changeJustification}</small>
            </span>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group mb-0">
          <button
            className="btn btn-secondary mr-2"
            name="cancelChange"
            onClick={handleClick_cancel}
          >
            Cancel Change
          </button>
          <button
            className="btn btn-primary"
            name="saveChangeJustification"
            onClick={handleSubmit}
          >
            OK
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default AdrTentativeAgreementChangeJustificationModalV3;
